<template>
  <div class="container">
    <div class="row">
      <div class="col 2-col">
        <h3>3.2 Suitability of SWC Interventions</h3>
        <p>
          The soil and water conservation section of the report is about
          mitigating issues identified in the previous sections, and offers
          conservation measures and suggestions that are most suitable to that
          specific environment. The algorithm takes into account landscape
          factors such as slope steepness, aridity, land cover, and soils, and
          then comes up with intervention measures that are appropriate for that
          type of landscape.
        </p>

        <RasterMap
          title="Soil and Water Conservation Suitability"
          v-if="!isJordan"
          attribution="Map: Geofolio. Data: Geofolio/WaterBalance/BRGM/CGIAR/Copernicus/WorldCover. Backgrounds: Mapbox/Openstreetmap Contributors [2]."
          v-bind:layout="{
            legendWidth: 5,
            legendCols: 2,
            descriptionWidth: 7,
            order: ['legend', 'description'],
          }"
          v-bind:location="location"
          v-bind:factsheet="factsheet"
          v-bind:loaded="loaded"
          v-bind:layers="layers"
          v-bind:extendedlegend="extendedLegend"
          v-bind:overlays="overlays"
          hideLayers="true"
          tip="<i class='bi bi-mouse2-fill'></i> <strong>Tip! Click the map or a stream</strong> to see details about SWC interventions. <strong>Right-click</strong> to explore imagery in a specific location."
          :contextMenu="['explore']"
          :clickAction="['interventions']"
        >
        </RasterMap>

        <RasterMap
          v-if="isJordan"
          title="SWC Jordan"
          attribution="Map: Geofolio. Backgrounds: Mapbox/Openstreetmap Contributors [2]."
          v-bind:layout="{
            legendWidth: 5,
            legendCols: 2,
            descriptionWidth: 7,
            order: ['legend', 'description'],
          }"
          v-bind:location="location"
          v-bind:factsheet="factsheet"
          v-bind:loaded="loaded"
          v-bind:layers="layersJordan"
          hideLayers="true"
          extendedLegendImage="/gfx/rwh_jordan_legend.png"
          :contextMenu="['explore']"
          :clickAction="[]"
        >
        </RasterMap>

        <div class="factsheet-caution-notice" v-if="warning != 'no'">
          <p>
            <strong
              ><i
                class="bi bi-exclamation-circle"
                style="font-size: 1.5em; float: left; margin-right: 8px"
              ></i>
              About using the soil and water conservation map</strong
            >
          </p>
          <p>
            This map should be used primarily for scoping, discovery, and
            educational purposes. It provides an indication of suitable SWC
            interventions based on relatively coarse global datasets. The actual
            local situation may be different from what is indicated on the map.
            Intervention planning and implementation should always be preceded
            by technical investigations on the ground.
          </p>
          <p>
            Contact us via support@geofolio.org if you would like us to improve
            the map for your area of interest using more accurate data sources.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import _ from "lodash";

import RasterMap from "@/components/factsheet/RasterMap.vue";
export default {
  name: "BaselineAtlas",
  components: { RasterMap },
  props: ["location", "factsheet", "loaded"],
  data() {
    return {
      layers: [
        {
          title: "Soil and Water Conservation",
          source: "/geofolio_rwh/swc_class_simplified_mercator.tif",
          long_description: "<p>Long desription</p>",
        },
      ],
      layersJordan: [
        {
          id: "598d3a17-dc4f-43f6-9b88-9d4e41f11998",
          name: "Jordan_RWH",
          description: "Jordan_RWH",
          long_description: "",
          version: 1,
          type: "qgislayer",
          label: "Jordan_RWH",
          rank: 500,
          legend: null,
        },
      ],
      overlays: [
        {
          title: "In-stream",
          dataset: "geofolio_swc_instream",
          layer: "streams.geojson",
          onclick: "swc_instream_panel",
        },
      ],
    };
  },
  created() {},
  computed: {
    extendedLegend() {
      /* Returns the extended legend */
      var l = this.factsheet.data["geofolio_rwh"]["extended_legend"];
      l["columns"] = ["color", "label"];
      l["titles"] = ["Color", "Description"];
      return l;
    },
    isJordan() {
      if (
        this.loaded &&
        this.factsheet &&
        this.factsheet["info"]["location"]["country"] == "jo"
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style>
div.map {
  width: 100%;
  height: 450px;
  display: block;
}
</style>
